<div class="api-docs-container">
    <div *ngIf="loadError" class="load-error">
        Failed to load the API documentation. Please refresh the page to try again.
    </div>
    <div #swaggerContainer></div>
</div>
